import type { FileStorageModuleClientDeps, FileStorageModuleClientType } from '../contracts/client';

export async function load(
  implementation: 'cet' | 'cloudinary' | 'local',
  deps: FileStorageModuleClientDeps
): Promise<FileStorageModuleClientType> {
  switch (implementation) {
    case 'cet':
      return (await import('../implementations/cet/src/client')).createClientFileStorageModule(deps);
    case 'cloudinary':
      return (await import('../implementations/cloudinary/src/client')).createClientFileStorageModule(deps);
    case 'local':
      return (await import('../implementations/local/src/client')).createClientFileStorageModule(deps);
    default:
      throw new Error(`Unknown file-storage client implementation: ${implementation || '<missing>'}`);
  }
}
